// wat doen we hier?
//      rekenen met openstaand saldo ER/EB & gekozen bedrag per maand
//      output aantal maanden, afgerond naar boven (want geld)

// uitwerken functie tonen tijdsduur
//      als maanden 1 is, ’1 maand’ tonen
//      als maanden 12 is ‘1 jaar’ tonen
//      als maanden meer dan 12 is, bereken jaar en maanden
class BetaalGemakProspect {
    constructor() {
        let self = this;
        self.betaalgemakForm = document.getElementById("betaalgemakForm");
        self.betaalgemakFormTextPlaceholder = document.getElementById(
            "betaalgemakFormTextPlaceholder"
        );
        if (self.betaalgemakForm) {
            self.outstandingAmountEREB = self.betaalgemakForm.dataset.amount;
            self.chosenAmountSelect = document.querySelector(
                self.betaalgemakForm.dataset.chosenamount
            );
            self.text = self.betaalgemakForm.dataset.text;
            self.textmonth = self.betaalgemakForm.dataset.textmonth;
            self.textmonths = self.betaalgemakForm.dataset.textmonths;
            self.textyear = self.betaalgemakForm.dataset.textyear;
            self.textyears = self.betaalgemakForm.dataset.textyears;

            self.textContainer = document.createElement("div");
            self.textContainerMessage = document.createElement("p");

            self.chosenAmountSelect.addEventListener(
                "change",
                self.calculatePaybackTime.bind(self)
            );
            self.addContainert();
            self.calculatePaybackTime();
        }
    }

    addContainert() {
        let self = this;
        self.betaalgemakFormTextPlaceholder.appendChild(self.textContainer);
        self.textContainer.classList.add("notification-block");
        self.textContainer.classList.add("notification-block--informative");
        self.textContainer.appendChild(self.textContainerMessage);
        self.textContainer.classList.add("notification-block__message");
        self.textContainer.innerHTML = self.text;
    }

    calculatePaybackTime() {
        let self = this;
        let chosenAmount = parseInt(self.chosenAmountSelect.value);
        let duration = "";
        let amountOfYears = "";
        let amountOfMonths = Math.ceil(
            self.outstandingAmountEREB / chosenAmount
        );
        let durationTarget = document.getElementById("duration");
        let amountTarget = document.getElementById("amount");

        if (amountOfMonths > 12) {
            amountOfYears = Math.floor(amountOfMonths / 12);
            amountOfMonths = amountOfMonths % 12;
        }

        if (amountOfMonths === 1) {
            duration = amountOfMonths + " " + self.textmonth;
        } else {
            duration = amountOfMonths + " " + self.textmonths;
        }

        if (amountOfYears >= 1 && amountOfMonths == 0) {
            duration = amountOfYears + " " + self.textyear;
        } else if (amountOfYears >= 1 && amountOfMonths >= 1) {
            duration = amountOfYears + " " + self.textyears + " en " + duration;
        }

        amountTarget.innerHTML = "€&nbsp;" + chosenAmount + ",00";
        durationTarget.innerHTML = duration.toString();
    }
}

document.addEventListener("DOMContentLoaded", function(event) {
    new BetaalGemakProspect();
});
